export { useCardPreviewBase_unstable as useCardPreview } from '@fluentui/react-card';
